import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';

import { MplListItem } from '@mopla/ui';

import { TOptionsConfig } from '../hooks/types';

interface IDTicketOptionsListSectionProps {
	options: TOptionsConfig;
}

export const DTicketOptionsListSection = ({
	options,
}: IDTicketOptionsListSectionProps) => {
	const { t } = useTranslation('userDTicket');

	if (!options || options.length === 0) {
		return null;
	}

	return (
		<Stack gap={2}>
			<Stack alignItems="center">
				<Typography variant="h3-sb" color="primary.main">
					{t('list_options.title')}
				</Typography>
			</Stack>

			<Stack gap={2}>
				{options.map(({ id, label, icon, onClick }) => (
					<MplListItem
						key={id}
						text={label}
						onClick={onClick}
						leftIcon={icon}
						dataTestid={`dticket-optionsList-${id}-listItem`}
					/>
				))}
			</Stack>
		</Stack>
	);
};
